module.exports = __webpack_public_path__ + "assets/img/3_1297_big.fb88196d.jpg";